import { render, staticRenderFns } from "./ManageSiteForm.vue?vue&type=template&id=20a9e28c&scoped=true"
import script from "./ManageSiteForm.vue?vue&type=script&lang=js"
export * from "./ManageSiteForm.vue?vue&type=script&lang=js"
import style0 from "./ManageSiteForm.vue?vue&type=style&index=0&id=20a9e28c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a9e28c",
  null
  
)

export default component.exports